import { render, staticRenderFns } from "./EditVertical.vue?vue&type=template&id=54b007c5"
import script from "./EditVertical.vue?vue&type=script&lang=js"
export * from "./EditVertical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports